import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class EndPageOptionsVM extends CommonOptionVM {

  constructor(data: Partial< EndPageOptionsVM> = {}) {
    super(data)
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default  EndPageOptionsVM